<div *ngIf="errorOccured" class="d-flex alert alert-info mb-0 bg-transparent border-0 p-0" role="alert">
    <i class="far fa-exclamation-triangle me-2"></i>
    <div>{{ serviceName }} is currently unavailable, please try again later.</div>
</div>
